<template>
  <div >
    <!-- 导航栏 -->
    <Header :title="$t('T_SEARCH_MODEL')" :link="$route.query.link || 'home'"></Header>
    <!-- 搜索框 -->
    <div class="appContent">
      <div class="ellipse-border clearfix" v-if="!$route.query.noSearch">
        <form action="/">
          <van-search
            v-model="inputForm.userInputModelName"
            :placeholder="$t('T_MODEL_SEARCH_TIPS')"
            background="transparent"
            @input="findMatchingModel"
            @search="findMatchingModel"
          >
            <div slot="left-icon" @click="findMatchingModel"><img src="@/assets/parts/search.png"/></div>
          </van-search>
        </form>
      </div>
      <!-- 列表展示 -->
      <div class="list-box">
        <div class="search-result">
          <van-cell>
            <template slot="title">
              <span class="search-list-title">{{$t('T_SEARCH_RESULT')}}:</span>
              <span class="search-num">{{searchMatchingModelData.length}}</span>
              <span class="search-model" v-if="searchMatchingModelData.length === 1 || searchMatchingModelData.length === 0">{{$t('T_RESULT')}}</span>
              <span class="search-model" v-else>{{$t('T_RESULTS')}}</span>
            </template>
          </van-cell>
        </div>
      </div>
      <div class="list-box list-result">
        <van-cell-group>
          <van-cell v-for='(item, index) in searchMatchingModelData' :key='index' :title="item.name" is-link @click='clickLink(item)'/>
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
// import ProjectorSpec from '@/assets/data/projectorSpec.json'
import Header from '@/components/header'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'searchProjectors',
  data () {
    return {
      inputForm: {
        userInputModelName: ''
      },
      userInput: '',
      isPress: false
    }
  },
  computed: {
    ...mapState([
      'searchMatchingModelData',
      'searchSelectedModelData',
      'searchMatchingLensID',
      'searchSelectedLensData',
      'position'
    ])
  },
  watch: {
    searchTabActiveName (val) {
      if (val === 'Search') {
        this.MATCHINGMODELDATA(this.searchMatchingModelData)
        this.SELECTEDMODELDATA(this.searchSelectedModelData)
        this.MATCHINGLENSID(this.searchMatchingLensID)
        this.SELECTEDLENSDATA(this.searchSelectedLensData)
      }
    }
  },
  created () {

  },
  mounted () {
    if (this.searchMatchingModelData.length > 0) {
      let searchMatchingModelDataSort = this.searchMatchingModelData
      searchMatchingModelDataSort.sort((obj1, obj2) => {
        return obj1.name.localeCompare(obj2.name)
      })
      this.setModelData(searchMatchingModelDataSort)
    }
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.onBrowserBack, false)
    }
  },
  destroyed () {
    if (window.history && window.history.pushState) {
      window.removeEventListener('popstate', this.onBrowserBack, false)
    }
  },
  methods: {
    ...mapMutations([
      'F_S2D',
      'F_D2S',
      'F_VOFFSET',
      'VLENSSHIFT',
      'HLENSSHIFT',
      'VHLENSSHIFT',
      'ASPECTRATIO',
      'SEARCHTABACTIVENAME',
      'SEARCHMATCHINGMODELDATA', 'SEARCHSELECTEDMODELDATA', 'SEARCHMATCHINGLENSID', 'SEARCHSELECTEDLENSDATA',
      'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'MATCHINGLENSID', 'SELECTEDLENSDATA', 'SET_TEMVLENSSHIFT'
    ]),
    clickLink (value) {
      let changeFlg = this.$store.state.selectedModelData.name !== value.name || this.$store.state.selectedModelData.code !== value.code
      this.SEARCHTABACTIVENAME('Search')
      this.setSelectedModelData(value)
      this.findMatchingLensAndSelectedLensData([value])
      this.$router.push({ name: 'projectorInfo', params: { modelChange: changeFlg } })
    },
    findMatchingModel () {
      let matchModelArr = []
      let userInputModelName = this.inputForm.userInputModelName.toLowerCase()
      this.ProjectorSpec.filter(item => {
        if (item.name.toLowerCase().indexOf(userInputModelName) !== -1) {
          matchModelArr.push(item)
        }
      })
      if (matchModelArr.length > 0) {
        matchModelArr.sort((obj1, obj2) => {
          return obj1.name.localeCompare(obj2.name)
        })
        this.setModelData(matchModelArr)
        this.findMatchingLensAndSelectedLensData(matchModelArr)
      } else {
        this.$toast.fail({
          message: this.$t('T_NO_RESULT'),
          duration: 1000
        })
      }
    },
    setModelData (value) {
      this.SEARCHMATCHINGMODELDATA(value)
      this.MATCHINGMODELDATA(value)
    },
    setLensData (idArr, data) {
      this.SEARCHMATCHINGLENSID(idArr)
      this.SEARCHSELECTEDLENSDATA(data)
      this.MATCHINGLENSID(idArr)
      this.SELECTEDLENSDATA(data)
    },
    findMatchingLensAndSelectedLensData (modelArr) {
      let selectedModelData = modelArr[0]
      let lensInfo = this.$commonJs.findLensInfo(selectedModelData)
      this.setLensData(lensInfo.matchingLensID, lensInfo.selectedLensInfo)
      return lensInfo.selectedLensInfo
    },
    setSelectedModelData (value) {
      // let selectedModelData = this.matchingModelData.find(
      //   item => item.name === value.name
      // )
      this.SELECTEDMODELDATA(value)
      this.SEARCHSELECTEDMODELDATA(value)
    },
    setSpecificInfo (data) {
      let defaultRatio = data.lcd.aspectRatio
      let defaultDistInfo = data.lcd.distInfo.find(
        item => item.ratio === defaultRatio
      )
      this.F_S2D(defaultDistInfo.size2dist)
      this.F_D2S(defaultDistInfo.dist2size)
      this.F_VOFFSET(defaultDistInfo.screenSizeToVOffset)

      this.VLENSSHIFT(data.lcd.lensShiftRange.v)
      this.SET_TEMVLENSSHIFT(data.lcd.lensShiftRange.v)
      this.HLENSSHIFT(data.lcd.lensShiftRange.h)
      this.VHLENSSHIFT(data.lcd.lensShiftRange.hv)
      this.ASPECTRATIO(data.lcd.aspectRatio)

      // 为超短焦设置默认vlens shift
      if (this.selectedModelData.type === 1 && data.lcd.lensShiftRange.v.min === 0 && data.lcd.lensShiftRange.v.max === 0) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        let v1b = defaultDistInfo.screenSize.w.min * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
        let res = (initSize.calY / 2 + v1b - data.mu) / initSize.calY
        this.SET_VLENSSHIFT(res)
        let vals = {}
        vals.max = res
        vals.min = res
        data.lcd.lensShiftRange.v = vals
        this.VLENSSHIFT(vals)
        this.SET_TEMVLENSSHIFT(vals)
      } else if (this.$commonViewJs.isLongLensExistsLens()) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        let res = (defaultDistInfo.wv.wv2 * defaultDistInfo.screenSize.w.min - initSize.calY / 2) / initSize.calY
        this.SET_VLENSSHIFT(res)
        let va = {}
        va.max = res
        va.min = res
        this.VLENSSHIFT(va)
        this.SET_TEMVLENSSHIFT(va)
      }
    },
    onBrowserBack () {
      let hash = window.location.hash
      if (hash === '#/searchProjectors') {
        this.$router.push({ path: '/' })
      }
    }
  },
  components: {
    Header
  }
}
</script>

<style>

</style>
<style scoped>
  .appContent{
    padding-top:9px
  }
  .list-result{
    height: calc(100% - 50px);
    overflow-y:auto
  }
  .ellipse-border {
    border:1px solid #e2e2e2;
    background: #f6f6f6;
  }
  .list-box{
    padding: 0 19px 0 19px
  }
  .search-model{
    color:#999;
    font-size: 14px
  }
  .van-cell{
    padding: 10px 0;
  }
  .search-result .van-cell{
    border-bottom: 1px solid #e6e6e6;
  }
  .van-cell:not(:last-child)::after{
    left:0;
    border-bottom: 1px solid #f0f0f0;
  }
</style>
